<template>
<el-form :model="formClub" ref="formClub" :label-position="'top'" >
    <el-form-item :label="label" prop="idseat" class="custom-label"
        :rules="[
          {required: true, message: 'Este campo es obligatorio', trigger: 'change'}
        ]">
        <el-select v-model="formClub.idseat" placeholder="Seleccione" filterable class="w-100" @change="getItemSeat">
            <el-option v-for="item in listSeats" :key="item.idseat" :label="item.name" :value="item.idseat"></el-option>
        </el-select>
    </el-form-item>

    <div class="text-right">
        <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('formClub')" :disabled="formClub.idseat == null ? true : false">Siguiente</button>
    </div>

</el-form>
</template>

<script>
export default {
    name: "ClubPark",
    props: {
      label: {
        type: String,
        required: false,
        default: 'Selecciona un club zonal o parque'
      },
      listSeats: {
        type: Array,
        required: true,
        default: []
      },
      setDefault: {
        type: String,
        required: false,
        default: ""
      }
    },
    data: () => ({
      formClub: {
        idseat: null
      }
    }),
    watch: {
      setDefault: {
        immediate: true, // Ejecuta la lógica cuando el componente se monta
        handler(newValue) {
          if (newValue) {
            this.formClub.idseat = newValue;
          }
        }
      }
    },
    methods: {
      getItemSeat(){
        return this.listSeats.find(item => item.idseat === this.formClub.idseat)
      },
      submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if (!valid)
            return false

          this.$store.dispatch("updateClubParque", this.getItemSeat());
          this.$emit('resClub', this.getItemSeat())
        })
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/ClubPark.vue